<template lang="pug">
  div
    template(
      v-if="loaded")
      v-card.mb-3(
        v-for="item in deliveries"
        :key="item.id")
        .list-mobile
          .list-mobile__top.list-mobile__top--offset-md
            .list-mobile__title {{ item.ingredient ? item.ingredient.name : '-' | shortstr }}
          .list-mobile__content
            .list-mobile__item
              .list-mobile__item-label {{ 'base.delivery_value' | translate }} [{{ 'base.kg' | translate }}]
              .list-mobile__item-value {{ item.amount | floor }}
            .list-mobile__item
              .list-mobile__item-label {{ 'base.price' | translate }} [{{ 'base.currency' | translate }}]
              .list-mobile__item-value {{ item.amount | floor }}
            .list-mobile__item
              .list-mobile__item-label {{ 'base.type' | translate }}
              .list-mobile__item-value {{ item.delivery_type === 'input' ? $t('base.delivery') : $t('base.sale') }}
            .list-mobile__item
              .list-mobile__item-label {{ 'base.company' | translate }}
              .list-mobile__item-value {{ item.delivery_company ? item.delivery_company.name : '-' }}
            .list-mobile__item
              .list-mobile__item-label {{ 'base.date' | translate }}
              .list-mobile__item-value {{ item.created_at | date }}
      v-table-body(
        v-if="loaded"
        outsideTable
        :empty="!deliveries.length")
    template(v-else)
      v-card.mb-3(v-for="i in 5" :key="i")
        .list-mobile.list-mobile--skeleton
          .list-mobile__top
            .list-mobile__title-skeleton
          .list-mobile__content
            .list-mobile__item(v-for="j in 5" :key="`${i}-${j}`")
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1
    template(
      v-if="loaded && deliveries.length")
      ui-pagination(
        v-model="page"
        offset-none
        :count="totalCount"
        @page-change="loadData")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'

export default {
  name: 'DeliveriesTableMobile',

  components: {
    UiPagination
  },

  data: () => ({
    page: 1,
    loaded: false
  }),

  computed: {
    ...mapGetters('deliveries', [
      'deliveries',
      'totalCount'
    ])
  },

  mounted () {
    this.loadData()
  },

  methods: {
    ...mapActions('deliveries', [
      'loadDeliveries'
    ]),

    async loadData () {
      const params = {
        farm: this.$route.params.farm_id,
        page: this.page
      }
      await this.loadDeliveries(params)
      this.loaded = true
    }
  },

  watch: {
    totalCount () {
      this.page = 1
    },

    page () {
      this.loaded = false
    }
  }
}
</script>
